var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1449 5.70762C14.5031 4.96785 13.5562 4.5 12.5 4.5C11.0033 4.5 9.72595 5.43951 9.22564 6.76097C8.85144 6.59327 8.43661 6.5 8 6.5C6.34315 6.5 5 7.84315 5 9.5C5 9.51673 5.00014 9.53343 5.00041 9.55009M15.1449 5.70762C15.5725 5.57274 16.0278 5.5 16.5 5.5C18.9853 5.5 21 7.51472 21 10C21 10.6296 20.8707 11.229 20.6372 11.773M15.1449 5.70762C13.7981 6.13239 12.7249 7.17345 12.2561 8.5C12.1435 8.81841 12.0658 9.15327 12.0275 9.5M5.00041 9.55009C4.83873 9.51724 4.67138 9.5 4.5 9.5C3.11929 9.5 2 10.6193 2 12C2 13.3807 3.11929 14.5 4.5 14.5H9.05001M5.00041 9.55009C5.01267 10.2988 5.2992 10.9808 5.76389 11.5M20.6372 11.773C20.2961 11.5985 19.9095 11.5 19.5 11.5C18.2905 11.5 17.2816 12.3589 17.05 13.5M20.6372 11.773C21.4462 12.187 22 13.0288 22 14C22 15.3807 20.8807 16.5 19.5 16.5C18.2904 16.5 17.4531 17.7082 17.8778 18.8408L18.5 20.5M9.05001 14.5C9.28164 15.6411 10.2905 16.5 11.5 16.5C11.7548 16.5 11.8823 16.5 11.9998 16.514C12.5855 16.5835 13.1107 16.9081 13.4348 17.4009C13.4999 17.4997 13.5569 17.6137 13.6708 17.8416L15 20.5M9.05001 14.5C9.01722 14.3384 9 14.1712 9 14C9 13.1822 9.39267 12.4561 9.99976 12",
    stroke: "#F2FCF7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemory);
export default __webpack_public_path__ + "static/media/Memory.8dd02882b86a66e5e1c6864c4e0e7706.svg";
export { ForwardRef as ReactComponent };